module.exports = __webpack_public_path__ + "static/media/Piercing-ear-rook.4cdd6d22.png";